import { Compare } from "@emberly/zenith-client";
import { IntegrationEnums, MissionEnums, MissionRequestEnums, OrderEnums, RoleIds } from "./constants";

export const ALL_OPEN_ORDERS = {
  name: "all_open_orders",
  or: [
    {
      path: "payment.method",
      comparer: Compare.EQ,
      value: OrderEnums.PaymentMethod.None
    },
    {
      path: "payment.invoice.state",
      comparer: Compare.EQ,
      value: OrderEnums.InvoiceState.None
    },
    {
      path: "payment.request.confirmed",
      comparer: Compare.EQ,
      value: false
    },
    {
      path: "payment.terminal.confirmed",
      comparer: Compare.EQ,
      value: false
    },
  ]
};

export const ALL_OPEN_ORDERS_WITH_MISSIONS = {
  name: "all_open_orders_with_missions",
  or: [
    {
      path: "payment.method",
      comparer: Compare.EQ,
      value: OrderEnums.PaymentMethod.None
    },
    {
      path: "payment.invoice.state",
      comparer: Compare.EQ,
      value: OrderEnums.InvoiceState.None
    },
    {
      path: "payment.request.confirmed",
      comparer: Compare.EQ,
      value: false
    },
    {
      path: "payment.terminal.confirmed",
      comparer: Compare.EQ,
      value: false
    },
  ]
};


export const ACTIVE_MISSIONS = {
  path: "state",
  comparer: Compare.EQ,
  value: MissionEnums.State.Created,
  name: "active_missions"
};


// Mission Requests

export const getAllReceivedRequestsFilter = (station) => ({
  name: "all_requests",
  path: "senderStationId",
  comparer: Compare.NEQ,
  value: station?.id
});


export const getAllSentRequestsFilter = (station) => ({
  name: "all_requests_sent",
  path: "senderStationId",
  comparer: Compare.EQ,
  value: station?.id
});



export const getNewReceivedRequestsFilter = (station) => ({
  name: "new_requests",
  and: [
    {
      path: "senderStationId",
      comparer: Compare.NEQ,
      value: station?.id
    },
    {
      path: "response",
      comparer: Compare.EQ,
      value: MissionRequestEnums.ResponseState.New,
    }
  ]
});

export const getNewSentRequestsFilter = (station) => ({
  name: "new_requests_sent",
  and: [
    {
      path: "senderStationId",
      comparer: Compare.EQ,
      value: station?.id
    },
    {
      path: "response",
      comparer: Compare.EQ,
      value: MissionRequestEnums.ResponseState.New,
    }
  ]
});


export const getAcceptedReceivedRequestsFilter = (station) => ({
  name: "accepted_requests",
  and: [
    {
      path: "senderStationId",
      comparer: Compare.NEQ,
      value: station?.id
    },
    {
      path: "response",
      comparer: Compare.EQ,
      value: MissionRequestEnums.ResponseState.Accepted,
    }
  ]
});

export const getAcceptedSentRequestsFilter = (station) => ({
  name: "accepted_requests_sent",
  and: [
    {
      path: "senderStationId",
      comparer: Compare.EQ,
      value: station?.id
    },
    {
      path: "response",
      comparer: Compare.EQ,
      value: MissionRequestEnums.ResponseState.Accepted,
    }
  ]
});


export const getRejectedReceivedRequestsFilter = (station) => ({
  name: "rejected_requests",
  and: [
    {
      path: "senderStationId",
      comparer: Compare.NEQ,
      value: station?.id
    },
    {
      path: "response",
      comparer: Compare.EQ,
      value: MissionRequestEnums.ResponseState.Rejected,
    }
  ]
});


export const getRejectedSentRequestsFilter = (station) => ({
  name: "rejected_requests_sent",
  and: [
    {
      path: "senderStationId",
      comparer: Compare.EQ,
      value: station?.id
    },
    {
      path: "response",
      comparer: Compare.EQ,
      value: MissionRequestEnums.ResponseState.Rejected,
    }
  ]
});



export const JOIN_ORDER_AND_MISSION = {
  path: "missionId",
  foreignPath: "id",
  collection: "Mission",
  as: "mission",
}

export const DRIVERS_QUERY = {
  path: "roles.id",
  comparer: Compare.EQ,
  value: RoleIds.Driver,
  name: "drivers_filter"
};

export const OPERATORS_QUERY = {
  path: "roles.id",
  comparer: Compare.EQ,
  value: RoleIds.Operator,
  name: "operators_filter"
};

export const FLEET_MGMT_INTEGRATION_QUERY = {
  path: "category",
  comparer: Compare.EQ,
  value: IntegrationEnums.Category.FleetManagement,
  name: "fleet_mgmt_integration_filter"
};


export const MISSION_TASK_VIEW_PROJECTION = {

  collectionId: (task) => task.missionId,

  toView: (mission) => mission.salvageTasks?.map(
    task => ({
      id: task.taskId,
      number: task.number,
      route: task.route,
      taskType: task.taskType,
      taskName: task.taskName,
      execution: task.execution,
      description: task.description,
      comment: task.comment,
      resolvedAtLocation: task.resolvedAtLocation,
      locationState: task.locationState,
      missionId: mission.id,
      missionState: mission.state,
      missionTarget: mission.target,
      missionDetails: mission.details,
      missionNumber: mission.number,
      organizationId: mission.organizationId,
      lastModified: mission.lastModified,
    })
  ),

  mapField: (field) => {
    const path = field.split(".");
    const rest = path.slice(1);

    switch (path[0]) {

      // full
      case "state": return "missionState";
      case "number": return "missionNumber";
      case "organizationId": return "organizationId";
      case "lastModified": return "lastModified";

      // partial
      case "details": return ["missionDetails", ...rest].join(".");
      case "target": return ["missionTarget", ...rest].join(".");

      // Skip these fields
      case "actors":
      case "storageTask":
      case "serviceInfo":
      case "files":
        return false;

      default:
        return null;
    }
  },

}



